/* Banana Manor - Colorful Oushaks lander behaviour: view switching + the 360 tour facade. */
(function () {
  function init() {
    var boxes = document.querySelectorAll('[data-bm-tour]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.getAttribute('data-bm-tour-ready')) { return; }
      box.setAttribute('data-bm-tour-ready', '1');
      var btn = box.querySelector('.tourlaunch');
      if (!btn) { return; }
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = box.getAttribute('data-bm-tour-src');
        f.title = box.getAttribute('data-bm-tour-title') || '360 degree virtual tour';
        f.setAttribute('allow', 'fullscreen; xr-spatial-tracking; gyroscope; accelerometer; magnetometer; vr');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        f.setAttribute('tabindex', '-1');
        box.appendChild(f);
        f.focus();
        if (btn.parentNode) { btn.parentNode.removeChild(btn); }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
}());
(function(){
  // One page, several views: the landing page itself (.bm-view-main), this hub, and one
  // panel per competitor (.bm-view). The url fragment picks which is on screen, so links
  // stay shareable and the browser back button works.
  function views(){ return Array.prototype.slice.call(document.querySelectorAll('.bm-view')); }
  function mains(){ return Array.prototype.slice.call(document.querySelectorAll('.bm-view-main')); }
  function ids(){ return views().map(function(v){ return v.id; }); }

  function show(id, move){
    var found = null;
    views().forEach(function(v){
      var match = (v.id === id);
      v.hidden = !match;
      if (match) { found = v; }
    });
    mains().forEach(function(m){ m.hidden = !!found; });
    if (move){
      var head = (found || mains()[0] || document.body).querySelector('h1, h2');
      if (head){ head.setAttribute('tabindex','-1'); head.focus({ preventScroll: true }); }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function fromHash(move){
    var frag = (location.hash || '').replace(/^#/, '');
    show(ids().indexOf(frag) > -1 ? frag : '', move);
  }

  document.addEventListener('click', function(e){
    if (!e.target.closest) { return; }
    var a = e.target.closest('a[href^="#"]');
    if (!a) { return; }
    var frag = (a.getAttribute('href') || '').replace(/^#/, '');
    // leave the landing page's own in-page anchors alone
    if (frag && ids().indexOf(frag) === -1) { return; }
    e.preventDefault();
    if ((location.hash || '').replace(/^#/, '') === frag) { fromHash(true); }
    else if (frag) { location.hash = frag; }
    else if (location.hash) { location.hash = ''; show('', true); }
    else { show('', true); }
  });

  window.addEventListener('hashchange', function(){ fromHash(true); });

  function init(){
    // Views ship visible, so with JS off every comparison is still readable, stacked
    // below the landing page. Collapse them only here, once the whole document is
    // parsed - this script sits above them in the markup.
    fromHash(false);
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
}());